import { useEffect } from 'react'
import Header from './components/Header'
import useResponsiveRoute from './routes/useResponsiveRoute'
import useAuth from './services/useAuth'

import { fetchVersion, fetchAppData } from './states/prefsActions'
import { catalogPollIntervalMs } from './configs/settings'

const style = {
  display: 'flex',
  justifyContent: 'space-between'
}

function App() {
  const { auth } = useAuth()
  const element = useResponsiveRoute(auth && auth.accessToken)

  useEffect(() => { fetchVersion() }, [])

  // dataVersion (fetchVersion, above) only changes on a real catalog
  // redeploy, so it can't gate this — poll app-data directly so a staff
  // availability toggle reaches sessions that already loaded the app
  useEffect(() => {
    const id = setInterval(fetchAppData, catalogPollIntervalMs)
    return () => clearInterval(id)
  }, [])

  return (
    <div>
      <Header />
      <div style={style}>{element}</div>
    </div>
  )
}

export default App
